// Owner in P2: piece 13 "Ego graph and connections" (docs/FILE-OWNERSHIP.md).
// The feature's entry file (docs/CONTRACTS.md section 16): `/connections`, one lazy chunk. The path carries one id (an
// organisation number, a register person or a contact) and never free text.
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Waypoints } from 'lucide-react'
import type { Feature } from '../feature.ts'
import { parseSearch } from './search.ts'

export const feature: Feature = {
  app: (parent) => [
    createRoute({
      getParentRoute: () => parent,
      path: '/connections',
      validateSearch: (search: Record<string, unknown>) => parseSearch(search),
      component: lazyRouteComponent(() => import('./ConnectionsScreen.tsx')),
    }),
  ],
  nav: [{ to: '/connections', label: 'nav.connections', icon: Waypoints, group: 'network', key: 'c' }],
}
